<div class="flex flex-wrap justify-center container-h py-3">
  <div
    class="flex flex-wrap w-full sm:w-11/12"
    [ngClass]="{
      'lg:w-8/12 md:w-10/12': store.option_layout.sizeXL(),
      'lg:w-6/12 md:w-8/12': !store.option_layout.sizeXL()
    }">
    <div class="flex flex-none justify-center md:justify-start items-center w-3/12">
      <img
        class="md:hidden block"
        [src]="this.resource.header.logo"
        alt="{{ this.resource.header.alt_logo }}" />
      <img
        class="md:block hidden"
        [src]="this.resource.header.logo_h"
        alt="{{ this.resource.header.alt_logo_h }}" />
    </div>
    <div class="shrink-0 flex flex-col w-7/12 space-y-1">
      <h1 class="title" [innerHTML]="layoutInfo()?.title"></h1>
      <h2 class="subtitle" [innerHTML]="layoutInfo()?.subtitle"></h2>
    </div>
    <div class="flex flex-none justify-center md:justify-end items-center cursor-pointer w-2/12">
      <app-progress-circle
        [progress]="(this.step() / this.maxStep()) * 100"
        [step]="stepShow()"
        [maxStep]="maxStepShow()"></app-progress-circle>
    </div>
  </div>
</div>
